export default {
  GET_INSURANCE_STATUS: "/api/v1/insurance/status", //보험 가입 여부확인
  GET_INSURANCE_DETAIL: "/api/v1/insurance", //보험 상세 조회
  GET_INSURANCE_DETAIL_BY_MID: "/api/v1/insurance/mid", //MerchantUID로 보험 상세 조회
  GET_INSURANCE_DOCUMENT: "/api/v1/insurance/document", //보험 문서 조회

  GET_VALID_DATE: "/api/v1/insurance/valid-date", //보험 결제 유효일자 조회
  GET_DEPOSIT_AMOUNT: "/api/v1/insurance/price", //보험 결제 금액 조회

  GET_PAYPLE_INFO: "/api/v1/insurance/payple/info", //보험 결제 payple 시작정보 조회
  POST_INSURANCE_PAYMENT_INIT: "/api/v1/insurance/payment/init", //보험 결제 시작

  PATCH_INSURANCE_CONTRACT_UPDATE: "/api/v1/insurance/contract", //보험 계약 정보 업데이트

  // 퍼스트아메리칸 권원보험(NZSC-3189) — 가입 퍼널 이벤트 기록(R3 FE연결, api-public)
  POST_FIRSTAM_FUNNEL_EVENT: "/api/v1/firstam/funnel-event",

  // 권원보험 랜딩 상담 신청(NZSC-3424) — 랜딩은 비로그인 노출이라 익명 허용 엔드포인트.
  // api-public 이 api-admin(internal/watson/firstam-lead)으로 중계해 왓슨에 적재한다.
  POST_FIRSTAM_CONSULT_LEAD: "/api/v1/firstam/consult-lead",

  // 권원보험 가입 대기 신청(NZSC-4248) — 최근 신청 1건(로그인 필수). 재신청 모달 판단용. 신청 저장은 web-core 화면이 한다.
  GET_FIRSTAM_WAITLIST_LATEST: "/api/v1/firstam/waitlist/latest",

  // [로컬 테스트 전용] 결제 웹훅 대체 — pending 주문 완료 처리(BE가 prod 차단). 실결제 없이 downstream 검증.
  POST_INSURANCE_TEST_PAYMENT_COMPLETE: "/api/v1/insurance-test/payment/complete",
};
